import React from 'react';
import { NavLink } from 'react-router-dom';
const Uganda1_subjects = () => {
  return (
    <div className='fixed top-24 right-0 left-0  justify-items-stretch w-full  content-center items-center z-200'>      
      <div className="h-24 grid grid-cols-6 flex bg-[#007bff]"> 
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_kindergarten" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Kindergarten</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_primary" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Primary: P1-P7</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_ordinary_secondary" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Secondary: S1-S4</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Secondary: S5-S6</NavLink> 
        <NavLink to="/tutoring/learner/uganda1/uganda1_mature_entry" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Mature Entry</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_university" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >University</NavLink>
      </div>  
    </div>
  );
}

export default Uganda1_subjects;
